import { createSelector } from 'reselect'
import { digObject } from 'functions/utilities'

const defaultFilter = (entityArray, filters) => entityArray.filter(entity => filters.every((filter) => {
  const { key, value } = filter
  const permittedValueArray = Array.isArray(value) ? value : [value]
  const includeNullValue = permittedValueArray.includes(null)
  const fieldValue = digObject(entity, key, includeNullValue ? null : undefined)

  return permittedValueArray.includes(fieldValue)
}))

const arrayFilter = (entityArray, filters) => entityArray.filter(entity => filters.every((filter) => {
  const { key, value, options } = filter
  const { arrayFilterField } = options || {}
  const permittedValueArray = Array.isArray(value) ? value : [value]
  const includeNullValue = permittedValueArray.includes(null)
  const fieldValue = arrayFilterField
    ? digObject(entity, key, [])
    : digObject(entity, key, includeNullValue ? null : undefined)

  if (arrayFilterField){
    return permittedValueArray.some(p => fieldValue.indexOf(p) !== -1)
  }

  return permittedValueArray.includes(fieldValue)
}))

const getFilteredEntities = (state, entityKey, filters = []) => {
  const entities = state.entities[entityKey]
  const entityArray = Object.values(entities)

  const hasArrayFilterField = filters.some(filter => digObject(filter, 'options.arrayFilterField', false))

  if (hasArrayFilterField){
    return arrayFilter(entityArray, filters)
  }

  return defaultFilter(entityArray, filters)
}

const multiFilteredObjectArraySelector = createSelector(
  [getFilteredEntities],
  entities => entities,
)

export default multiFilteredObjectArraySelector
